import React from 'react'
import { ContentStylizer } from '@retailer-platform/shared-components'

interface FeatureHighlightIntroductionProps {
  featureDescriptions: string[]
}

const FeatureHighlightIntroduction = ({
  featureDescriptions = [],
}: FeatureHighlightIntroductionProps) => (
  <ContentStylizer>
    <h1>Introducing new tools on Instacart Platform Portal</h1>
    <h3>What&apos;s new?</h3>
    <p>You can now</p>
    <ul>
      {featureDescriptions.map((description, idx) => (
        <li key={idx}>{description}</li>
      ))}
    </ul>
  </ContentStylizer>
)

export default FeatureHighlightIntroduction
